import { AttentionCardAppointmentCaseModel } from './_attention_card.controller';

export function getAppointmentParticipantsText($case: AttentionCardAppointmentCaseModel): string {
	if ($case.participantCount > 2) return `${$case.actingHcp?.name ?? '-'} +${$case.participantCount - 1}`;

	return $case.actingHcp?.name ?? '-';
}
